import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText } from '@prismicio/react';
import { ImageField, RichTextField } from '@prismicio/types';
import { FC } from 'react';
import dynamic from 'next/dynamic';

const StarfieldBackground = dynamic(
  () => import('@/components/StarfieldBackground'),
  { ssr: false },
);

interface WithLogoOnTopProps {
  slice: {
    slice_type: string;
    variation: string;
  };
  title: RichTextField;
  image: ImageField<never>;
}

const WithLogoOnTop: FC<WithLogoOnTopProps> = ({ slice, title, image }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="relative text-white pt-32 pb-24 md:pt-48 md:pb-40 overflow-hidden"
    >
      <StarfieldBackground />
      <div className="container mx-auto px-10 py-20 flex flex-col items-center text-center">
        <PrismicNextImage
          field={image}
          className="w-[160px] object-contain mb-6"
          alt=""
        />
        <h2 className="text-white font-inter font-extrabold text-[56px] leading-[120%]">
          <PrismicRichText field={title} />
        </h2>
      </div>
    </section>
  );
};

export default WithLogoOnTop;
